import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StatusParcelaEnum } from '../shared/enums/status-parcela.enum';
import { Contrato } from '../shared/models/contrato.model';
import { Parcela } from '../shared/models/parcela.model';

@Component({
  selector: 'app-parcelas',
  templateUrl: './parcelas.component.html',
  styleUrls: ['./parcelas.component.scss']
})
export class ParcelasComponent {

  @Input()
  set contratoSelecionado(contrato: Contrato) {
    this.contratoSelecionadoIntercept = contrato;
    this.codContrato = (contrato) ? contrato.contrato : '';
    this.checkParcelas();
  }

  get contratoSelecionado(): Contrato {
    return this.contratoSelecionadoIntercept;
  }

  private contratoSelecionadoIntercept: Contrato;

  @Output()
  parcelaSelecionada = new EventEmitter<Parcela>();

  parcelas: Array<Parcela> = new Array<Parcela>();

  codContrato: string;

  qtdeParcelasTotal = 0;

  rendering = false;

  @Input()
  isMobile: boolean;

  private checkParcelas(): void {
    this.rendering = false;
    this.parcelas = this.contratoSelecionado && this.contratoSelecionado.parcelas;
    this.qtdeParcelasTotal = (this.parcelas) ? this.parcelas.length : 0;
    this.fakeRender();
  }

  convertToDatabaseDate(date: string): string {
    if (date) {
      const dateSplit = date.split('-');
      return `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;
    }
    return null;
  }

  selecionarParcela(parcela: Parcela): void {
    this.parcelaSelecionada.emit(parcela);
  }

  permitirGerarSegundaVia(statusParcela: StatusParcelaEnum | string): boolean {
    if (statusParcela === StatusParcelaEnum.STATUS_PAGO
      || statusParcela === StatusParcelaEnum.STATUS_FORA_RANGE_ACORDO) {
      return false;
    }
    return true;
  }

  /**
   * Fake Render para o Angular Material Renderizar
   */
  private fakeRender(): void {

    if (this.isMobile && this.parcelas) {
      // this.loadingService.show();
      setTimeout(() => {
        this.rendering = true;

      }, 200);
    }
  }

}
